<template>
     <b-alert :show="errorLoadingData" variant="danger" style="text-align: center">
          Sorry we are unable to fetch the required information at this time.<br/>
          If this continues then please contact your local Travel Centre<br/>
          <strong>{{branchNumber}}</strong>
        </b-alert>
</template>

<script>
import dayjs from '@/lib/dayjs';
export default {
    props:['errorLoadingData'],
    computed: {
     branchNumber() {
      return this.$store.getters['booking/getBranchTelephone'] || ""
    },
    
    // Used for the footer
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    }
  },
  
}
</script>
